module.exports = __webpack_public_path__ + "ec98f3c1f771f25f5ee42cbef0f6cc57.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/vg.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/vg.svg
// module chunks = 0